import React, { useCallback, useState } from 'react';
import ImageCropModal from '../components/ImageCropModal';

// Abre o recorte antes do upload. Uso:
//   const { cropImages, cropModal } = useImageCrop();
//   const files = await cropImages(e.target.files, { aspect: 1, allowSkip: true });
//   if (!files) return; // cancelado
// e renderize {cropModal} no JSX da página.
export default function useImageCrop() {
  const [job, setJob] = useState(null);

  const cropImages = useCallback((fileList, opts = {}) => {
    const files = Array.from(fileList || []);
    if (!files.length) return Promise.resolve(null);
    return new Promise((resolve) => setJob({ files, opts, resolve }));
  }, []);

  const finish = (value) => { job.resolve(value); setJob(null); };

  const cropModal = job && (
    <ImageCropModal
      files={job.files}
      aspect={job.opts.aspect ?? 1}
      allowSkip={job.opts.allowSkip}
      onDone={finish}
      onCancel={() => finish(null)}
    />
  );

  return { cropImages, cropModal };
}
